import React from 'react';
import Collapse from '../Collapse';
import * as S from './styled';

const Resolution = () => (
  <S.Container>
    <Collapse title="Entenda como são as comissões de venda e as participações societárias dos intermediários para o Cap Ganhador">
      <S.SubText>
        Nos termos da Resolução CNSP nº 382/2020, a Caixa Capitalização S.A.
        informa que a CAIXA, por meio de sua subsidiária integral Caixa
        Seguridade Participações S.A., detém participação societária direta
        sobre a Caixa Seguros Holding S.A., no percentual de 48,21% e, indireta
        sobre a Wiz Soluções e Corretagem de Seguros S.A., no percentual de
        12,05%. Informamos ainda que a Caixa Seguros Holding S.A. detém
        participação societária direta sobre a Wiz Soluções e Corretagem de
        Seguros S.A., com percentual de 25%. A Caixa Capitalização S.A. remunera
        seus intermediários entre 113% e 150% pela comercialização do título Cap
        Ganhador - pagamento mensal e entre 3,55% e 3,8% pela comercialização do
        título Cap Ganhador - pagamento único.
      </S.SubText>
    </Collapse>
  </S.Container>
);

export default Resolution;
